module.exports = function(videoId, hash, rate) {
    var ytPlayer = new YT.Player(
        'bgMovie--' + hash, // 埋め込む場所をIDで設定
        {
            videoId: videoId,
            playerVars: {
                rel: 0,
                loop: 1,
                playlist: videoId,
                controls: 0,
                autoplay: 1,
                //showinfo: 0,
                disablekb: 0,
                wmode : "transparent",
                modestbranding: 1
            },
            events: {
                'onReady': function(event){
                    onPlayerReady(event, hash, rate);
                }
            }
        }
    );
}
//プレイ準備完了後
function onPlayerReady(event, hash, rate) {
    $('.section--top--' + hash + ' .section--top__main').addClass('is--current');
    event.target.setPlaybackRate(rate);
    event.target.playVideo();
    event.target.mute();
}



// WEBPACK FOOTER //
// ./es2015/module/_yt_api.js